module.exports = __webpack_public_path__ + "media/images/hub-logo-4b9d8c9874a376c5f1f882c915be1f26.png";